import { GridValueFormatterParams } from '@mui/x-data-grid';
import Util from './Util';

export default class TableUtil {
  static formatDateCell(params: GridValueFormatterParams): string {
    return Util.dateFormatter(params.value);
  }
}
